<div class="row mt-5" *ngIf="planBenefits">
  <div class="col-12">
    <app-card-container>
      <div class="row">
        <div class="col-12">
          <div class="header-text">Plan Benefits</div>
        </div>
      </div>
      <div class="row mt-5 mb-3">
        <div class="col-4 table-title">Description</div>
        <div class="col-4 table-title">Qty</div>
        <div class="col-4 table-title">Value</div>
        <div class="col-12 border-gray mt-2"></div>
      </div>
      <div class="row mb-3" *ngFor="let item of planBenefits; let ii = index">
        <div class="row">
          <div class="col-12 section-header mt-3 mb-2">{{item.itemName}}</div>
        </div>
        <div class="row mt-2" *ngFor="let items of item.value; let a = index">
          <div class="col-4 mb-3">{{items.column1}}</div>
          <div class="col-4 mb-3">{{items.column2}}</div>
          <div class="col-4 mb-3">{{items.column3}}</div>
          <div class="col-12 border-gray"></div>
        </div>
      </div>
      
      <!-- Additional Benefits Link -->
      <div class="row mt-4" *ngIf="ancillaryCodes && ancillaryCodes.trim()">
        <div class="col-12">
          <p class="ancillary-text">
            Additional Benefits are available as part of your plan, 
            <a routerLink="/ancillary-benefits" class="ancillary-link">click here</a> for more details.
          </p>
        </div>
      </div>
    </app-card-container>
  </div>
</div>